// Static French content used across the site.

export const HERO = {
  eyebrow: "Noëmie · ta sorcière préférée",
  title: "Bienvenue dans",
  titleAccent: "La Maison de ta Sorcière Préférée",
  copy: `Ici, tu peux réserver un véritable temps rien que pour toi.

Tu choisis ta prestation et, lorsque cela est nécessaire, ton créneau.

À l'heure réservée, tu n'as rien à faire.

Aucun appel.
Aucune visio.

Pendant le temps prévu, je me consacre pleinement à ta séance.

À la fin, tu reçois ton compte rendu par WhatsApp ou par e-mail, selon ta préférence.`,
};

export const FEATURE_STRIP = [
  { icon: "PhoneOff", title: "Aucun appel" },
  { icon: "VideoOff", title: "Aucune visio" },
  { icon: "Moon", title: "Séance à distance" },
  { icon: "FileText", title: "Compte rendu personnel" },
];

export const HOW_IT_WORKS = [
  { n: "1", t: "Je choisis ma prestation" },
  { n: "2", t: "Je règle ma séance" },
  { n: "3", t: "Je transmets mes informations" },
  { n: "4", t: "Je réserve mon créneau si nécessaire" },
  { n: "5", t: "Noëmie réalise ma séance" },
  { n: "6", t: "Je reçois mon compte rendu" },
];

export const ABOUT = {
  intro: `Je m'appelle Noëmie, et peut-être que tu me connais déjà sous le nom de « ta sorcière préférée ».

L'intuition, les ressentis, les cartes, l'énergétique et tout ce qui touche à l'invisible font partie de ma vie depuis toute petite.

Ce n'est pas quelque chose que j'ai découvert récemment ni un univers dans lequel je suis entrée par curiosité.

J'ai toujours fonctionné comme ça.

Depuis l'enfance, je ressens beaucoup, je capte énormément de choses, je travaille avec mon intuition et j'ai naturellement été attirée par les cartes, les symboles, les énergies et tout ce qui ne se voit pas forcément mais qui peut parfois se ressentir très fort.

Avec les années, j'ai appris à mieux comprendre cette sensibilité, à l'écouter et à l'utiliser à ma manière.

Aujourd'hui, je pratique notamment les oracles, la médiumnité, les ressentis intuitifs et différentes approches énergétiques.

Mais je ne suis pas là pour te dire quoi faire ni pour prendre des décisions à ta place.

Mon rôle est de te proposer un espace dans lequel tu peux recevoir un autre éclairage sur ce que tu traverses, prendre du recul et écouter ce qui résonne en toi.`,
  work: `Je fonctionne énormément à l'intuition.

Je n'ai pas besoin d'un appel ou d'une visioconférence pour consacrer pleinement mon attention à une personne.

À l'heure de ta séance, je m'installe avec ton prénom, ton nom, ta photo, ta demande et les outils qui me correspondent.

Pendant le temps que tu as réservé, je me consacre entièrement à ta séance.

Oracles, ressentis, intuition, énergétique… je laisse les choses se présenter naturellement plutôt que de forcer un déroulé identique pour tout le monde.

Puis je te transmets mon retour directement par WhatsApp ou par e-mail.`,
  free: `Tu gardes toujours ton libre arbitre.

Je ne souhaite pas créer de dépendance aux tirages, utiliser la peur ou présenter mes ressentis comme des vérités absolues.

Un tirage peut éclairer un chemin.

Il ne doit jamais choisir le chemin à ta place.`,
  closing: `Bienvenue dans La Maison de ta Sorcière Préférée. ✨

Noëmie`,
};

export const FAQ = [
  { q: "Qu'est-ce qu'un tirage intuitif ?", a: "C'est une lecture de cartes guidée par l'intuition et les ressentis plutôt que par une grille d'interprétation figée. Je m'appuie sur les cartes, les symboles et ce qui se présente pour t'offrir un éclairage sur ta situation." },
  { q: "Comment fonctionne un tirage de cartes à distance ?", a: "Tu choisis ta prestation et me transmets ta demande. À l'heure prévue, je réalise ton tirage de mon côté, puis je t'envoie ton compte rendu écrit. Tu n'as rien à faire pendant ce temps." },
  { q: "Faut-il être présente en appel ou en visio ?", a: "Non. Toutes les prestations sont réalisées sans appel ni visioconférence. Tu peux continuer ta journée normalement." },
  { q: "Comment Noëmie réalise-t-elle ses tirages ?", a: "Je m'installe avec ton prénom, ton nom, ta demande, ta photo si nécessaire et mes outils. Je laisse les cartes, mes ressentis et mon intuition se présenter naturellement, puis je te transmets mon retour par écrit." },
  { q: "Peut-on poser une question précise ?", a: "Oui. Pour SOS Sorcière, tu poses une seule question précise. Pour les autres tirages, tu peux explorer une problématique ou plusieurs interrogations autour d'un même sujet." },
  { q: "Quelles informations faut-il transmettre ?", a: "Ton prénom, ton nom, une photo récente selon la prestation et, pour un tirage, ta question ou ton intention. Ces informations restent strictement confidentielles." },
  { q: "Un tirage prédit-il exactement l'avenir ?", a: "Non. Je ne prédis pas ton avenir avec certitude. Un tirage éclaire ton présent et t'aide à comprendre ce qui se joue. Tu gardes toujours ton libre arbitre." },
  { q: "Comment réserver un tirage ?", a: "Tu choisis ta prestation, tu règles en ligne de façon sécurisée et, si un créneau est nécessaire, tu le réserves après le paiement. Sinon, tu transmets simplement tes informations." },
  { q: "Comment fonctionne une séance énergétique à distance ?", a: "Je réalise un travail énergétique intuitif à distance (ancrage, harmonisation, recentrage selon la séance), puis je partage les ressentis et éléments qui se sont présentés. C'est une démarche de bien-être et d'introspection, jamais un acte médical." },
  { q: "Comment fonctionne Entre Lui et Moi ?", a: "C'est un abonnement mensuel : chaque mois, tu reçois physiquement un courrier préparé par Noëmie (un verset, une guidance liée à ton signe, un petit mot et une attention papier). Il est résiliable à tout moment depuis ton espace." },
  { q: "Comment fonctionne le Guide Tarot ?", a: "Le Guide Visuel Complet du Tarot est un produit numérique (78 cartes, 78 fiches A4 et 9 bonus), imprimable et consultable sur téléphone, tablette ou ordinateur. Après l'achat, tu y accèdes depuis la rubrique « Mes contenus » de ton espace." },
];

export const AVERTISSEMENT = `Les guidances, lectures intuitives, tirages d'oracles et séances énergétiques proposés par La Maison de ta Sorcière Préférée s'inscrivent dans une démarche de spiritualité, d'introspection personnelle, de bien-être et de divertissement.

Ils ne constituent en aucun cas un acte médical ou paramédical, un diagnostic, un traitement, une prescription, une psychothérapie ou un avis professionnel de nature médicale, psychologique, psychiatrique, juridique ou financière.

Noëmie n'intervient pas en qualité de médecin, psychologue, psychiatre ou professionnel de santé et ne prétend pas posséder les qualifications attachées à ces professions.

Les prestations proposées ne doivent jamais conduire à retarder, interrompre, modifier ou refuser un traitement ou un suivi auprès d'un professionnel qualifié.

Toute personne présentant un symptôme, une souffrance physique ou psychologique ou s'interrogeant sur son état de santé est invitée à consulter un professionnel compétent.

Aucune prédiction, interprétation, perception intuitive ou information communiquée au cours d'une prestation ne constitue une certitude ou une garantie quant à la survenance d'un événement futur.

Le client demeure pleinement responsable de ses choix, de ses décisions et de l'utilisation qu'il fait des informations communiquées.

Une guidance peut éclairer un chemin.
Elle ne doit jamais choisir le chemin à la place du client.`;

export const NATURE_PRESTATIONS = `Les prestations proposées par La Maison de ta Sorcière Préférée relèvent exclusivement de la guidance spirituelle, de l'introspection personnelle, du bien-être et du divertissement.

Elles peuvent notamment comprendre des tirages d'oracles, des ressentis intuitifs, des guidances, de la médiumnité et des pratiques énergétiques non médicales.

Elles ne constituent en aucun cas un acte médical ou paramédical, un diagnostic, un traitement, une prescription, une psychothérapie ou un avis professionnel médical, psychologique, psychiatrique, juridique ou financier.

Noëmie Sartore n'intervient pas en qualité de médecin, psychologue, psychiatre ou professionnel de santé.

Les prestations proposées ne doivent jamais conduire à retarder, interrompre, modifier ou refuser un traitement ou un suivi auprès d'un professionnel qualifié.

Toute personne présentant des symptômes, une souffrance physique ou psychologique ou une inquiétude relative à sa santé est invitée à consulter un professionnel compétent.`;

export const ABSENCE_GARANTIE = `Les guidances, ressentis et interprétations sont par nature subjectifs.

Ils ne constituent aucune certitude ni garantie concernant un événement présent ou futur.

Les prestations énergétiques ne font l'objet d'aucune promesse de résultat médical, thérapeutique, reproductif, professionnel, sentimental ou financier.

Le Client conserve son libre arbitre et demeure seul responsable de ses choix et décisions.`;

export const PROPRIETE_INTELLECTUELLE = `L'ensemble des textes, contenus, éléments graphiques, logo, identité visuelle, photographies, illustrations et contenus originaux présents sur La Maison de ta Sorcière Préférée sont protégés par les règles relatives à la propriété intellectuelle.

Toute reproduction, représentation, adaptation, diffusion ou exploitation totale ou partielle est interdite sans autorisation écrite préalable de Noëmie Sartore, sous réserve des exceptions prévues par la loi.`;

export const CONSENTS = [
  { key: "cgv", label: "J'ai lu et j'accepte les Conditions Générales de Vente." },
  { key: "majeur", label: "Je confirme avoir 18 ans ou plus." },
  { key: "nature_spirituelle", label: "J'ai compris que cette prestation relève de la spiritualité, de l'introspection et du bien-être et ne constitue pas un acte ou avis médical." },
  { key: "execution_immediate", label: "Je demande expressément que l'exécution de ma prestation puisse commencer avant la fin du délai légal de rétractation de 14 jours. Je reconnais qu'après exécution complète de la prestation, je perdrai mon droit de rétractation." },
];

export const PHOTO_PRIVACY = `La photo transmise est utilisée uniquement dans le cadre de la prestation réservée.

Elle n'est jamais publiée ni utilisée à des fins commerciales.`;

export const BOOKING_NOTICE = `Tu n'as pas besoin d'être présente pendant le créneau que tu réserves.

Ce créneau correspond au moment pendant lequel Noëmie réalise ta séance de son côté.

Il n'y aura ni appel ni visioconférence.

Tu recevras ensuite ton compte rendu selon le mode que tu as choisi. ✨`;
